var render = function render(){
  var _vm$lawyer6, _vm$lawyer6$section;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-page', {
    scopedSlots: _vm._u([{
      key: "subHead",
      fn: function () {
        var _vm$lawyer, _vm$lawyer2, _vm$lawyer3, _vm$lawyer4, _vm$lawyer5;
        return [_c('v-card', {
          staticStyle: {
            "background-attachment": "fixed"
          },
          attrs: {
            "tile": "",
            "height": _vm.$vuetify.breakpoint.lgAndUp ? '800' : 'auto',
            "img": "/images/common/lawyer/subvisual-lawyer-bg.jpg"
          }
        }, [_c('v-container', {
          staticClass: "d-flex h-100"
        }, [_c('div', {
          staticClass: "w-100 mt-80px mt-lg-auto"
        }, [_c('v-row', {
          attrs: {
            "no-gutters": "",
            "align-md": "end",
            "justify": "center",
            "justify-md": "space-between"
          }
        }, [_c('v-col', {
          staticClass: "d-none d-md-block",
          attrs: {
            "cols": "1"
          }
        }), _c('v-col', {
          attrs: {
            "cols": "12",
            "md": "auto"
          }
        }, [_c('div', {
          staticClass: "mb-20px mb-md-0"
        }, [_c('v-img', {
          staticClass: "mx-auto",
          attrs: {
            "max-width": _vm.$vuetify.breakpoint.lgAndUp ? '438' : '280',
            "src": `/images/lawyer/${(_vm$lawyer = _vm.lawyer) === null || _vm$lawyer === void 0 ? void 0 : _vm$lawyer.code}.png`
          }
        })], 1)]), _c('v-col', {
          attrs: {
            "cols": "12",
            "md": ""
          }
        }, [_c('div', {
          staticClass: "mb-40px mb-md-60px mb-lg-80px text-center text-md-right white--text",
          attrs: {
            "data-aos": "fade-up",
            "data-aos-duration": "600",
            "data-aos-anchor-placement": "top-bottom"
          }
        }, [_c('div', {
          staticClass: "tit-wrap tit-wrap--sm"
        }, [_c('h3', {
          staticClass: "font-size-30 font-size-md-60 font-size-lg-72 line-height-11"
        }, [_vm._v(_vm._s((_vm$lawyer2 = _vm.lawyer) === null || _vm$lawyer2 === void 0 ? void 0 : _vm$lawyer2.name))]), _c('div', {
          staticClass: "tit tit--xs font-weight-medium line-height-11 white--text mt-6px mt-md-10px"
        }, [_vm._v(_vm._s((_vm$lawyer3 = _vm.lawyer) === null || _vm$lawyer3 === void 0 ? void 0 : _vm$lawyer3.rank))])]), _c('div', [_c('v-row', {
          staticClass: "row--sm txt white--text",
          attrs: {
            "justify": "center",
            "justify-md": "end"
          }
        }, [_c('v-col', {
          attrs: {
            "cols": "auto"
          }
        }, [_c('strong', [_vm._v("Direct")])]), _c('v-col', {
          attrs: {
            "cols": "auto"
          }
        }, [_c('span', [_vm._v(_vm._s((_vm$lawyer4 = _vm.lawyer) === null || _vm$lawyer4 === void 0 ? void 0 : _vm$lawyer4.phone))])])], 1)], 1), _c('div', {
          staticClass: "pt-4px pt-md-8px"
        }, [_c('v-row', {
          staticClass: "row--sm txt white--text",
          attrs: {
            "justify": "center",
            "justify-md": "end"
          }
        }, [_c('v-col', {
          attrs: {
            "cols": "auto"
          }
        }, [_c('strong', [_vm._v("Email")])]), _c('v-col', {
          attrs: {
            "cols": "auto"
          }
        }, [_c('span', [_vm._v(_vm._s((_vm$lawyer5 = _vm.lawyer) === null || _vm$lawyer5 === void 0 ? void 0 : _vm$lawyer5.email))])])], 1)], 1)])])], 1)], 1)])], 1)];
      },
      proxy: true
    }])
  }, [_c('page-section', {
    staticClass: "page-section--first pb-0"
  }, [_c('div', {
    staticClass: "tit-wrap tit-wrap--sm"
  }, [_c('h3', {
    staticClass: "tit tit--xl tit--point line-height-11"
  }, [_c('span', [_vm._v("Introduction")]), _c('span', {
    staticClass: "tit--point__circle",
    attrs: {
      "data-aos": "zoom-in"
    }
  })])]), _c('div', {
    staticClass: "txt line-height-15 overflow-hidden",
    attrs: {
      "data-aos": "fade",
      "data-aos-duration": "600"
    }
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s((_vm$lawyer6 = _vm.lawyer) === null || _vm$lawyer6 === void 0 ? void 0 : (_vm$lawyer6$section = _vm$lawyer6.section1) === null || _vm$lawyer6$section === void 0 ? void 0 : _vm$lawyer6$section.txt.replace(/\n/gi, '<br/>'))
    }
  })])]), _c('page-section', {
    staticClass: "page-section--xs page-section--last"
  }, [_c('v-divider', {
    staticClass: "grey darken-4",
    staticStyle: {
      "border-width": "2px 0 0"
    }
  }), _c('v-expansion-panels', {
    staticClass: "font-secondary",
    attrs: {
      "flat": "",
      "multiple": ""
    }
  }, [_c('v-expansion-panel', [_c('v-expansion-panel-header', {
    staticClass: "pa-12px px-md-20px py-md-24px border-b"
  }, [_c('div', {
    staticClass: "tit tit--xxs font-weight-medium"
  }, [_vm._v("Practice Areas")])]), _c('v-expansion-panel-content', {
    staticClass: "grey lighten-5"
  }, [_c('div', {
    staticClass: "px-12px py-16px px-md-20px py-md-24px px-lg-60px py-lg-40px border-b"
  }, _vm._l(_vm.lawyer.section2, function (section, index) {
    return _c('page-section', {
      key: index,
      staticClass: "page-section--xxs pb-0",
      class: {
        'pt-0': index == 0
      },
      scopedSlots: _vm._u([{
        key: "pageSectionImmersive",
        fn: function () {
          return [_c('div', {
            staticClass: "pb-10px pb-md-12px"
          }, [_c('div', {
            staticClass: "tit tit--xs"
          }, [_vm._v(_vm._s(section === null || section === void 0 ? void 0 : section.title))])]), _vm._l(section.columns, function (columns, index) {
            return _c('div', {
              key: index,
              class: {
                'pt-8px pt-md-10px': index != 0
              }
            }, [_c('v-row', {
              staticClass: "row--xs txt txt--sm line-height-15"
            }, [_c('v-col', [_c('v-row', {
              staticClass: "row--xs"
            }, [_c('v-col', {
              attrs: {
                "cols": "auto"
              }
            }, [_vm._v("·")]), _c('v-col', [_c('div', [_vm._v(_vm._s(columns === null || columns === void 0 ? void 0 : columns.txt))])])], 1)], 1)], 1)], 1);
          })];
        },
        proxy: true
      }], null, true)
    });
  }), 1)])], 1), _c('v-expansion-panel', [_c('v-expansion-panel-header', {
    staticClass: "pa-12px px-md-20px py-md-24px border-b"
  }, [_c('div', {
    staticClass: "tit tit--xxs font-weight-medium"
  }, [_vm._v("Education")])]), _c('v-expansion-panel-content', {
    staticClass: "grey lighten-5"
  }, [_c('div', {
    staticClass: "px-12px py-16px px-md-20px py-md-24px px-lg-60px py-lg-40px border-b"
  }, _vm._l(_vm.lawyer.section3, function (section, index) {
    return _c('div', {
      key: index,
      class: {
        'pt-8px pt-md-10px': index != 0
      }
    }, [_c('v-row', {
      staticClass: "row--xs txt txt--sm line-height-15"
    }, [_c('v-col', {
      attrs: {
        "cols": "12",
        "md": "auto"
      }
    }, [_c('div', {
      staticClass: "txt--dark font-weight-medium min-w-md-90px"
    }, [_vm._v(_vm._s(section === null || section === void 0 ? void 0 : section.title))])]), _c('v-col', [_c('v-row', {
      staticClass: "row--xs"
    }, [_c('v-col', {
      attrs: {
        "cols": "auto"
      }
    }, [_vm._v("·")]), _c('v-col', [_c('div', [_vm._v(_vm._s(section === null || section === void 0 ? void 0 : section.txt))])])], 1)], 1)], 1)], 1);
  }), 0)])], 1), _c('v-expansion-panel', [_c('v-expansion-panel-header', {
    staticClass: "pa-12px px-md-20px py-md-24px border-b"
  }, [_c('div', {
    staticClass: "tit tit--xxs font-weight-medium"
  }, [_vm._v("Professional Career")])]), _c('v-expansion-panel-content', {
    staticClass: "grey lighten-5"
  }, [_c('div', {
    staticClass: "px-12px py-16px px-md-20px py-md-24px px-lg-60px py-lg-40px border-b"
  }, _vm._l(_vm.lawyer.section4, function (section, index) {
    return _c('div', {
      key: index,
      class: {
        'pt-8px pt-md-10px': index != 0
      }
    }, [_c('v-row', {
      staticClass: "row--xs txt txt--sm line-height-15"
    }, [_c('v-col', {
      attrs: {
        "cols": "12",
        "md": "auto"
      }
    }, [_c('div', {
      staticClass: "txt--dark font-weight-medium min-w-md-90px"
    }, [_vm._v(_vm._s(section === null || section === void 0 ? void 0 : section.title))])]), _c('v-col', [_c('v-row', {
      staticClass: "row--xs"
    }, [_c('v-col', {
      attrs: {
        "cols": "auto"
      }
    }, [_vm._v("·")]), _c('v-col', [_c('div', [_vm._v(_vm._s(section === null || section === void 0 ? void 0 : section.txt))])])], 1)], 1)], 1)], 1);
  }), 0)])], 1), _c('v-expansion-panel', [_c('v-expansion-panel-header', {
    staticClass: "pa-12px px-md-20px py-md-24px border-b"
  }, [_c('div', {
    staticClass: "tit tit--xxs font-weight-medium"
  }, [_vm._v("Representative Matters")])]), _c('v-expansion-panel-content', {
    staticClass: "grey lighten-5"
  }, [_c('div', {
    staticClass: "pa-12px px-md-20px py-md-24px px-lg-60px py-lg-40px"
  }, _vm._l(_vm.lawyer.section5, function (section, index) {
    return _c('page-section', {
      key: index,
      staticClass: "page-section--xxs pb-0",
      class: {
        'pt-0': index == 0
      },
      scopedSlots: _vm._u([{
        key: "pageSectionImmersive",
        fn: function () {
          return [_c('div', {
            staticClass: "pb-10px pb-md-12px"
          }, [_c('div', {
            staticClass: "tit tit--xs"
          }, [_vm._v(_vm._s(section === null || section === void 0 ? void 0 : section.title))])]), _vm._l(section.columns, function (column, index) {
            return _c('div', {
              key: index,
              class: {
                'pt-8px pt-md-10px': index != 0
              }
            }, [_c('v-row', {
              staticClass: "row--xs txt txt--sm line-height-15"
            }, [_c('v-col', {
              attrs: {
                "cols": "12",
                "md": "auto"
              }
            }, [_c('div', {
              staticClass: "txt--dark font-weight-medium min-w-md-90px"
            }, [_vm._v(_vm._s(column === null || column === void 0 ? void 0 : column.title))])]), _c('v-col', [_c('v-row', {
              staticClass: "row--xs"
            }, [_c('v-col', {
              attrs: {
                "cols": "auto"
              }
            }, [_vm._v("·")]), _c('v-col', [_c('div', [_vm._v(_vm._s(column === null || column === void 0 ? void 0 : column.txt))])])], 1)], 1)], 1)], 1);
          })];
        },
        proxy: true
      }], null, true)
    });
  }), 1)])], 1)], 1), _c('div', {
    staticClass: "btn-wrap btn-wrap--lg"
  }, [_c('v-row', {
    attrs: {
      "justify": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-btn', {
    staticClass: "min-w-120px min-w-lg-160px",
    attrs: {
      "x-large": "",
      "outlined": "",
      "color": "primary"
    },
    on: {
      "click": function ($event) {
        return _vm.$router.go(-1);
      }
    }
  }, [_vm._v("Back to list")])], 1)], 1)], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }